/**
 * Vendor Bills saga functions
 */
import { call, put, takeEvery } from 'redux-saga/effects';
import Actions from './actions';
import Constants from '../../constants';
import UserAPI from '../../Lib/Api/user';
import { handleError } from '../../Lib/Utils/saga-utils';

const { VendorBills, VendorBill } = Constants;
const {
  getVendorBillsSuccess,
  getVendorBillsError,
  getVendorBillError,
  getVendorBillSuccess,
} = Actions;

/**
 * Gets vendor bills and dispatches success or error.
 *
 *  @param {object} action:
 *  {
 *    @property {string} userId: the user id
 *    @property {string} params: query params
 *  }
 */
export function* getVendorBills({ userId, params }) {
  try {
    const response = yield call(UserAPI.getVendorBills, userId, params);
    yield put(getVendorBillsSuccess(response));
  } catch (err) {
    yield handleError(getVendorBillsError, err);
  }
}

/**
 * Gets a vendor bill and dispatches success or error
 *
 * @param {object} action:
 * {
 *   @property {number} userId
 *   @property {number} vendorBillId
 * }
 */
export function* getVendorBill({ userId, vendorBillId }) {
  try {
    const response = yield call(UserAPI.getVendorBill, userId, vendorBillId);
    yield put(getVendorBillSuccess(response));
  } catch (err) {
    yield handleError(getVendorBillError, err);
  }
}

/**
 * Allows multiple requests to fetch vendor bills to happen concurrently.
 */
function* vendorBillsSaga() {
  yield takeEvery(VendorBills.GET_VENDOR_BILLS, getVendorBills);
  yield takeEvery(VendorBill.GET_VENDOR_BILL, getVendorBill);
}

export default vendorBillsSaga;
